export const DataPayslipItemCategory = {
    monthly_gross: 'Monthly Gross Revenue',
    hourly_rate_70: 'Hourly Wage Rate_70',
    daily_rate_60: 'Daily Wage Rate_60',
    frais_repr_20: 'Frais Forfaitaires de Représentation_20',
    meal_allow_23: 'Meal Allowances_23',
    meal_adj_23: 'Meal Allowances_23 Adjustment',
    frais_effectifs_21: 'Autres Frais Effectifs_21',
    frais_opt_24: "Frais d'Optimisations_24",
    frais_opt_adj_24: "Frais d'Optimisations_24 Adjustment",
    indem_maladie_avs: 'Indemnité Maladie Numeriq AVS',
    bonus_30: 'Bonus_30',
    commissions_36: 'Commissions_36',
    additional_gross_90: 'Additional Gross Revenue_90',
    gross_adj_95: 'Gross Revenue Adjustment_95',
    numeriq_fees_13: 'Numeriq Fees %_13',
    numeriq_fees_fixed_14: 'Numeriq Fees Fixed_14',
    numeriq_fix_adj_17: 'Numeriq Fixes Adjustment_17',
    indem_apg_military_25: 'Indemnités APG Militaire_25',
    indem_accident1_26: 'Indemnités Accident1_26',
    indem_maladie_assur_27: 'Indemnités Maladie Assurances_27',
    allocation_mat_28: 'Allocation Maternité_28',
    allocation_parent_29: 'Allocation Complémentaire Autre Parent/Adoption_29',
    illness_allow_numeriq_34: 'Illness Allowances Numeriq_34',
    cot_lpp_emp_31: 'Cotisation LPP Employé_31',
    cot_lpp_employer_32: 'Cotisation LPP Employeur_32',
    cot_lpp_comp_emp_33: 'Cotisation LPP Compl. Employé_33',
    cot_lpp_comp_employer_43: 'Cotisation LPP Compl. Employeur_43',
    frais_clients_47: 'Frais Clients_47',
    frais_clients_adj_47: 'Frais Clients_47 Adjustment',
    payroll_deductions_48c: 'Payroll Deductions_48c',
    salary_advance_49: 'Salary Advance_49',
    rattrapage_impot_37: "Rattrapage de l'Impôt à la Source de l'Année Précédente_37",
};
